import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class reporteGeneralService {
    /******* QUERIES ******/

    async general(filter) {
        const response = await axios
            .get(`${ERP}logistica/reporte-general/general?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async resumen(filter) {
        const response = await axios
            .get(`${ERP}logistica/reporte-general/resumen?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excelGeneral(filter) {
        const response = await axios
            .get(`${ERP}logistica/reporte-general/excel-general?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };   


    async excelResumen(filter) {
        const response = await axios
            .get(`${ERP}logistica/reporte-general/excel-resumen?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async excelDetallado(filter) {
        const response = await axios
            .get(`${ERP}logistica/reporte-general/excel-detallado?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async detalladoEstablecimientoAlmacen(filter) {
        const response = await axios
            .get(`${ERP}logistica/reporte-general/detallado/establecimiento-almacen?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async detalladoProducto(filter) {
        const response = await axios
            .get(`${ERP}logistica/reporte-general/detallado/producto?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async detalladoMovimiento(filter) {
        const response = await axios
            .get(`${ERP}logistica/reporte-general/detallado/movimiento?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new reporteGeneralService();